module.exports = __webpack_public_path__ + "images/error-card/error.jpg";